import { map } from 'rxjs/operators';
import { Constants } from 'src/app/util/constants';
import { YearCollegeTypeMappingService } from './../../../../providers/yearCollegeMapping/year-college-type-mapping.service';
import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UserDataService } from 'src/app/providers/userData/user-data.service';

@Component({
	selector: 'app-common-field',
	standalone: false,
	templateUrl: './common-field.component.html',
	styleUrls: ['./common-field.component.scss']
})
export class CommonFieldComponent implements OnInit {
	@Input() pageSpecificFormObject;
	@Input() formTypeId;
	@Output() commonFieldEmitter: EventEmitter<any> = new EventEmitter<any>();

	minimumCheckInDate;
	minimumCheckOutDate;
	maximumDate;
	yearToCollegeMapping: any = [];
	isIQACADMIN: boolean = false;
	isWEBEQUI: boolean = false;
	isOFFICE_CO: boolean = false;
	loggedInUserName;
	isFROMIQACDASHBOARD: boolean = false;
	yearFromList: any = [];

	customModalOptionsFromYear = {
		header: 'From year',
		breakpoints: [0, 0.75],
		initialBreakpoint: 0.75
	};

	constructor(
		public datePipe: DatePipe,
		public userdataService: UserDataService,
		public collegeTypeYearMappingService: YearCollegeTypeMappingService
	) {}

	ngOnInit() {
		this.userdataService.getCurrentActiveSection().then((section) => {
			if (section) {
				if (section === 'IQAC_DASHBORAD') {
					this.isFROMIQACDASHBOARD = true;
				} else {
					this.isFROMIQACDASHBOARD = false;
				}
			}
		});
		this.getUserInfo();
		this.checkLoggedInUserRole();
		//this.fetchAllCollegeTypeYearMappingsForCollegeId();
		let today = new Date();
		let tomorrow = new Date();
		tomorrow.setDate(tomorrow.getDate() + 1);
		let max = new Date();
		max.setFullYear(max.getFullYear(), max.getMonth(), max.getDate());
		// this.maximumDate = this.datePipe.transform(max, 'yyyy-MM-dd');

		this.userdataService.getUserProfile().then((profile) => {
			if (profile) {
				this.userdataService.getToken().then((token) => {
					this.collegeTypeYearMappingService
						.fetchCollegeTypeYearMapping(token, {
							collegeId: profile.college.id
						})
						.subscribe(
							(response) => {
								this.yearToCollegeMapping = response.mappings
									? response.mappings.sort(Constants.YearFromComparator)
									: [];
								this.yearToCollegeMapping.forEach((mapping) => {
									if (mapping.yearFrom == this.pageSpecificFormObject.yearFrom) {
										this.pageSpecificFormObject.collegeType = mapping.collegeType;
									}
								});
							},
							(error) => {
								console.log(error);
							}
						);
				});
			}
		});
	}

	fetchAllCollegeTypeYearMappingsForCollegeId(collegeId) {
		this.userdataService.getToken().then((token) => {
			this.collegeTypeYearMappingService
				.fetchCollegeTypeYearMapping(token, {
					collegeId: collegeId
				})
				.subscribe(
					(response) => {
						// console.log(response);
						this.yearToCollegeMapping = response.mappings ? response.mappings.sort(Constants.YearFromComparator) : [];
						if (this.yearToCollegeMapping) {
							this.yearFromList = this.yearToCollegeMapping.map((mapping) => {
								return mapping.yearFrom;
							});
						}
					},
					(error) => {}
				);
		});
	}

	getUserInfo() {
		this.userdataService.getUserProfile().then((profile) => {
			if (profile) {
				this.loggedInUserName = profile.emailId;
				this.fetchAllCollegeTypeYearMappingsForCollegeId(profile.college.id);
			}
		});
	}
	checkLoggedInUserRole() {
		this.userdataService.getLoggedInUserRole().then((roles) => {
			if (roles) {
				if (roles.includes('IQAC_ADMIN')) {
					this.isIQACADMIN = true;
				}
				if (roles.includes('WEB_EQUI')) {
					this.isWEBEQUI = true;
				}
				if (roles.includes('OFFICE_EQUI')) {
					this.isOFFICE_CO = true;
				}
			}
		});
	}
	yearFromChange(event) {
		let enteredValue = event.target.value;
		if (enteredValue !== '' && enteredValue !== undefined) {
			let millis = Date.parse(event.target.value.substring(0, 10));
			let millisOfCurrentYear = Date.parse(event.target.value.substring(0, 10));
			let nextYearOfSelectedDate = new Date(millis);
			let currentYear = new Date(millisOfCurrentYear);
			nextYearOfSelectedDate.setDate(nextYearOfSelectedDate.getDate() + 366);
			this.pageSpecificFormObject.yearTo = this.datePipe.transform(nextYearOfSelectedDate, 'yyyy');
			this.pageSpecificFormObject.yearFrom = this.datePipe.transform(currentYear, 'yyyy');
			this.yearToCollegeMapping.forEach((mapping) => {
				if (mapping.yearFrom == this.pageSpecificFormObject.yearFrom) {
					this.pageSpecificFormObject.collegeType = mapping.collegeType;
				}
			});
			this.commonFieldEmitter.emit(this.pageSpecificFormObject);
		}
	}
	canUpdate(): boolean {
		if (this.pageSpecificFormObject.status != undefined) {
			return (
				this.pageSpecificFormObject.id &&
				this.isIQACSubsection() &&
				(this.pageSpecificFormObject.status == 'CREATED' ||
					(this.pageSpecificFormObject.status == 'REVERTED' &&
						this.loggedInUserName == this.pageSpecificFormObject.createdBy) ||
					(this.pageSpecificFormObject.status == 'RECALLED' &&
						this.loggedInUserName == this.pageSpecificFormObject.createdBy) ||
					(this.pageSpecificFormObject.status == 'RESENT' &&
						this.loggedInUserName == this.pageSpecificFormObject.createdBy) ||
					(this.pageSpecificFormObject.status == 'SHARED' &&
						this.loggedInUserName != this.pageSpecificFormObject.createdBy))
			);
		} else {
			return true;
		}
	}
	isIQACSubsection(): boolean {
		var result =
			!this.isFROMIQACDASHBOARD ||
			(this.pageSpecificFormObject.formTypeDTO !== undefined &&
				this.pageSpecificFormObject.formTypeDTO.fomSubSection !== undefined &&
				this.pageSpecificFormObject.formTypeDTO.fomSubSection.id !== undefined &&
				this.pageSpecificFormObject.formTypeDTO.fomSubSection.id === 31);
		return result;
	}

	// isApproved(): boolean {
	//   return Constants.IS_APPROVED(this.pageSpecificFormObject);
	// }
}
